exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader[data-v-1626dcc6] {\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  width: 178px;\n  height: 178px;\n}\n.avatar-uploader[data-v-1626dcc6]:hover {\n  border-color: #409eff;\n}\n.avatar-uploader-icon[data-v-1626dcc6] {\n  font-size: 28px;\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar[data-v-1626dcc6] {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n", ""]);

// exports
